<template>
  <JournalList />
</template>

<script>
import JournalList from './views/JournalList.vue'

export default {
  name: 'App',
  components: {
    JournalList
  }
}
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-text);
  min-height: 100vh;
  background: var(--color-bg);
}
</style>
